import { useContext } from 'react';
import { UserContext } from '@/stores/user-context.tsx';

export const useAuth = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error(
      "useAuth deve essere utilizzato all'interno di UserProvider",
    );
  }
  return context;
};
